// Maps each insurance type (from QuotePage Step 2) to relevant carriers.
// priority: true = green-highlighted carriers from the carrier list (show first).

export const CARRIERS_BY_TYPE = {
  home: [
    { name: "Aegis",                       url: "https://aegiseasy.com/",                                          priority: true },
    { name: "Foremost",                    url: "https://www.foremost.com/",                                       priority: true },
    { name: "Bamboo",                      url: "https://bambooinsurance.com/",                                    priority: true },
    { name: "American Modern",             url: "https://policyholders.amig.com/", logoDomain: "amig.com",          priority: true },
    { name: "California Fair Plan",        url: "https://www.cfpnet.com/",                                         priority: true },
    { name: "Travelers",                   url: "https://www.travelers.com/",                                      priority: true },
    { name: "State National",              url: "https://www.statenational.com/",                                  priority: true },
    { name: "SPINNAKER",                   url: "https://spinnakerins.com/",                                       priority: true },
    { name: "Mount Vernon Fire",           url: "https://www.usli.com/",                                           priority: true },
    { name: "KW Specialty",                url: "https://kwspecialty.com/",                                        priority: true },
    { name: "GeoVera",                     url: "https://geovera.com/" },
    { name: "Delos",                       url: "https://www.getdelos.com/" },
    { name: "Homesite",                    url: "https://go.homesite.com/" },
    { name: "Obie",                        url: "https://www.obieinsurance.com/" },
    { name: "Burns & Wilcox",              url: "https://www.burnsandwilcox.ca/" },
    { name: "Berkshire Hathaway GUARD",    url: "https://www.guard.com/" },
    { name: "The Hartford",                url: "https://www.thehartford.com/" },
    { name: "USLI",                        url: "https://www.usli.com/" },
    { name: "Tower Hill Specialty",        url: "https://www.thig.com/companies/tower-hill-specialty/" },
    { name: "Pacific Specialty",           url: "https://www.pacificspecialty.com/" },
    { name: "LIO Insurance",               url: "https://lioinsurance.com/" },
    { name: "Steadily",                    url: "https://www.steadily.com/" },
    { name: "Markel",                      url: "https://www.markel.com/" },
    { name: "Nationwide",                  url: "https://www.nationwide.com/" },
    { name: "Scottsdale Insurance",        url: "https://www.nationwide.com/" },
    { name: "Bridge Specialty",            url: "https://bridgespecialtygroup.com/" },
    { name: "Hudson Insurance Group",      url: "https://hudsoninsgroup.com/" },
    { name: "Benchmark Ins Co",            url: "https://www.benchmarkinsco.com/" },
    { name: "Chubb Commercial",            url: "https://www.chubb.com/us-en/business-insurance.html" },
  ],

  auto: [
    { name: "Bristol West",                url: "https://www.bristolwest.com/",                                    priority: true },
    { name: "National General",            url: "https://nationalgeneral.com/" },
    { name: "Progressive Commercial",      url: "https://www.progressivecommercial.com/" },
    { name: "Hagerty",                     url: "https://www.hagerty.com/" },
    { name: "United Financial Casualty",   url: "https://www.unitedcasualty.com/" },
  ],

  life: [
    { name: "The Hartford",                url: "https://www.thehartford.com/" },
    { name: "Nationwide",                  url: "https://www.nationwide.com/" },
  ],

  business: [
    { name: "biBerk",                      url: "https://www.biberk.com/",                                         priority: true },
    { name: "NEXT",                        url: "https://www.nextinsurance.com/",                                   priority: true },
    { name: "Pie Insurance",               url: "https://www.pieinsurance.com/",                                    priority: true },
    { name: "THREE",                       url: "https://threeinsurance.com/",                                      priority: true },
    { name: "Hiscox",                      url: "https://www.hiscox.com/",                                          priority: true },
    { name: "Aegis",                       url: "https://aegiseasy.com/",                                          priority: true },
    { name: "Thimble",                     url: "https://app.thimble.com/" },
    { name: "Coterie",                     url: "https://coterieinsurance.com/" },
    { name: "Simply Business",             url: "https://www.simplybusiness.com/" },
    { name: "Attune",                      url: "https://www.attuneinsurance.com/" },
    { name: "AmTrust",                     url: "https://amtrustfinancial.com/" },
    { name: "Burns & Wilcox",              url: "https://www.burnsandwilcox.ca/" },
    { name: "The Hartford",                url: "https://www.thehartford.com/" },
    { name: "USLI",                        url: "https://www.usli.com/" },
    { name: "Kinsale",                     url: "https://www.kinsaleins.com/" },
    { name: "Markel",                      url: "https://www.markel.com/" },
    { name: "Harborway",                   url: "https://www.harborwayinsurance.com/" },
    { name: "FoxQuilt",                    url: "https://www.foxquilt.com/" },
    { name: "Semsee",                      url: "https://semsee.com/" },
    { name: "Pathpoint",                   url: "https://www.pathpoint.com/" },
    { name: "Employers",                   url: "https://www.employers.com/" },
    { name: "Cowbell Cyber",               url: "https://cowbell.insure/" },
    { name: "SES Risk Solutions",          url: "https://www.ses-ins.com/" },
    { name: "Integrated Specialty (ISC)",  url: "https://www.iscmga.com/" },
    { name: "Annex Risk",                  url: "https://www.annexrisk.com/" },
    { name: "Chubb Commercial",            url: "https://www.chubb.com/us-en/business-insurance.html" },
    { name: "MGT",                         url: "https://www.mgtinsurance.com/" },
    { name: "Kemper Commercial",           url: "https://www.kemper.com/" },
    { name: "Nationwide",                  url: "https://www.nationwide.com/" },
    { name: "Fortegra",                    url: "https://www.fortegra.com/" },
    { name: "Berkshire Hathaway Home State (BHHC)",                    url: "https://bhhc.com/" },
    { name: "biBerk",                      url: "https://www.biberk.com/" },
  ],

  health: [
    { name: "Anthem Blue Cross",           url: "https://www.anthem.com/" },
    { name: "Blue Shield of CA",           url: "https://www.blueshieldca.com/" },
    { name: "Kaiser Permanente",           url: "https://about.kaiserpermanente.org/" },
  ],

  travel: [
    { name: "Thimble",                     url: "https://app.thimble.com/" },
    { name: "Slice",                       url: "https://sliceinsurance.com/" },
  ],

  renters: [
    { name: "NEXT",                        url: "https://www.nextinsurance.com/",                                   priority: true },
    { name: "Bamboo",                      url: "https://bambooinsurance.com/",                                    priority: true },
    { name: "Hiscox",                      url: "https://www.hiscox.com/",                                          priority: true },
    { name: "ePremium",                    url: "https://www.epremium.com/" },
    { name: "Steadily",                    url: "https://www.steadily.com/" },
    { name: "National General",            url: "https://nationalgeneral.com/" },
    { name: "Foremost",                    url: "https://www.foremost.com/",                                       priority: true },
  ],

  umbrella: [
    { name: "Travelers",                   url: "https://www.travelers.com/",                                      priority: true },
    { name: "RLI",                         url: "https://www.rlicorp.com/" },
    { name: "Berkshire Hathaway GUARD",    url: "https://www.guard.com/" },
    { name: "Burns & Wilcox",              url: "https://www.burnsandwilcox.ca/" },
    { name: "The Hartford",                url: "https://www.thehartford.com/" },
    { name: "USLI",                        url: "https://www.usli.com/" },
    { name: "Nationwide",                  url: "https://www.nationwide.com/" },
    { name: "Markel",                      url: "https://www.markel.com/" },
    { name: "Kinsale",                     url: "https://www.kinsaleins.com/" },
  ],

  disability: [
    { name: "The Hartford",                url: "https://www.thehartford.com/" },
    { name: "Nationwide",                  url: "https://www.nationwide.com/" },
    { name: "Employers",                   url: "https://www.employers.com/" },
    { name: "State Compensation Ins Fund", url: "https://www.statefundca.com/" },
  ],

  flood: [
    { name: "Neptune Flood",               url: "https://neptuneflood.com/" },
    { name: "Wright Flood",                url: "https://www.wrightflood.com/" },
    { name: "Superior Flood",              url: "https://www.mysuperiorflood.com/" },
    { name: "GeoVera",                     url: "https://geovera.com/" },
    { name: "Coastal Select / GeoVera",    url: "https://geovera.com/coastal-select/" },
    { name: "California Fair Plan",        url: "https://www.cfpnet.com/",                                         priority: true },
    { name: "BTIS",                        url: "https://marketplace.btisinc.com/" },
  ],

  identity: [
    { name: "IDIQ",                        url: "https://www.idiq.com/partnerships/insurance" },
  ],
};
